import React from 'react';
import { Image, Source } from '@unpic/react';
import FocusPointFigure from '../../FocusPointFigure';

interface IHelpCenterGalleryImageProps {
  heroImage: {
    title: string;
    url: string;
    width: number;
    height: number;
  };
}
const HelpCenterHeroImage = ({ heroImage }: IHelpCenterGalleryImageProps) => (
  <FocusPointFigure focusPoint="top-left">
    <picture>
      {['avif', 'webp', null].map((format) => (
        <Source
          key={`hero-${format || 'default'}`}
          sizes="(min-width: 770px) 200px, 100vw"
          breakpoints={[200, 300, 400, 600, 700]}
          type={format && `image/${format}`}
          src={heroImage.url}
          width={heroImage.width}
          height={heroImage.height}
          layout="constrained"
        />
      ))}
      <Image
        sizes="(min-width: 770px) 200px, 100vw"
        breakpoints={[200, 300, 400, 600, 700]}
        priority
        alt={heroImage.title}
        src={heroImage.url}
        width={heroImage.width}
        height={heroImage.height}
        layout="constrained"
      />
    </picture>
  </FocusPointFigure>
);

export default HelpCenterHeroImage;
